import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./History.css"
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "./Header";
import Footer from "./Footer";
const History = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0);   // scroll to top
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <>
            <Header />
            <div className="history-page">

                {/* <!-- subtle heritage line + identifier (no header, just style) -->
<!-- mini hero (matching about-hero feeling but compact) --> */}
                <div className="history-hero">
                    <div className="floating-element-history"></div>
                    <div className="floating-element-history"></div>
                    <div className="content-container">
                        <h1 className="hero-title" data-aos="fade-up">AI meets O’Hanlon legacy</h1>
                        <p className="hero-sub" data-aos="fade-up" data-aos-delay="100">Proprietary AI gets you to 80% · O’Hanlon attorneys take it to 100%</p>
                    </div>
                </div>

                {/* <!-- MAIN NARRATIVE: principle blocks (like collaboration/mission style) --> */}
                <div className="content-container" style={{ marginTop: "-3rem", position: "relative", zIndex: "5" }}>
                    {/* <!-- block 1 --> */}
                    <div className="principle-block" data-aos="fade-right">
                        <div className="principle-icon"><i className="fa-solid fa-gauge-high"></i></div>
                        <div className="principle-text">
                            <h2><i>80%</i> foundation · <i>100%</i> strength</h2>
                            <p>A good AI system helps you draft invention summaries, organize technical flows, and suggest early claim language. That saves time and builds the foundation. But real patent attorneys push further: they tighten claims, anticipate objections, and align your patent with business goals.</p>
                            <span className="stat-marker"><i className="fa-regular fa-clock"></i> AI starts the race – attorney finishes strong</span>
                            <div className="highlight-quote" style={{ marginTop: "1.5rem" }}>⚡ You don’t need to choose between speed and safety</div>
                        </div>
                    </div>

                    {/* <!-- block 2 --> */}
                    <div className="principle-block" data-aos="fade-left">
                        <div className="principle-icon"><i className="fa-solid fa-brain"></i></div>
                        <div className="principle-text">
                            <h2>Strong patents start with <i>the right questions</i></h2>
                            <p>Real attorneys think beyond what your tech does today: how it evolves, how it might get copied, where it’s most valuable. AI focuses on inputs; attorneys think like investors and rivals. <strong>“What’s defensible? What can we protect that others might miss?”</strong></p>
                        </div>
                    </div>

                    {/* <!-- block 3 --> */}
                    <div className="principle-block" data-aos="fade-right">
                        <div className="principle-icon"><i className="fa-solid fa-shield-halved"></i></div>
                        <div className="principle-text">
                            <h2>You avoid mistakes <i>before</i> they happen</h2>
                            <p>Most rejected patents don’t fail because of a bad idea. They fail because of bad filing: claims too broad, descriptions too light, prior art overlooked. AI can’t always spot those issues. Attorneys bring pattern recognition from hundreds of cases. They catch what AI misses — and save months of costly rework.</p>
                        </div>
                    </div>

                    {/* <!-- block 4 --> */}
                    <div className="principle-block" data-aos="fade-left">
                        <div className="principle-icon"><i className="fa-solid fa-pen-fancy"></i></div>
                        <div className="principle-text">
                            <h2>Clarity + muscle = <i>balance</i></h2>
                            <p>One big risk: language gets too dense, too legal. That confuses examiners. AI keeps things simple. But simple isn't always strong. Attorneys know how to make claims precise without being weak — the balance between broad protection and clear novelty. That’s everything.</p>
                        </div>
                    </div>

                    {/* <!-- block 5 = collaboration, not conflict --> */}
                    <div className="principle-block" data-aos="fade-right">
                        <div className="principle-icon"><i className="fa-solid fa-handshake"></i></div>
                        <div className="principle-text">
                            <h2>Collaboration, not conflict</h2>
                            <p>Myth: AI and attorneys are at odds. Reality: the smartest legal teams use AI as first step — move faster, handle more filings, give each one attention. The attorney isn’t fighting the system; they’re supercharging it. AI organizes and accelerates. The attorney shapes and secures. You get a patent that actually protects your edge.</p>
                        </div>
                    </div>
                </div>

                {/* <!-- founder / startup focused section (similar to team / mission cards) --> */}
                <div className="content-container">
                    <div className="founder-note" data-aos="zoom-in">
                        <h3 style={{ fontSize: "2rem", color: "#0B1E4A" }}>This isn’t just about saving time. It’s about getting it right. <span style={{ fontWeight: "300", fontSize: "1.2rem", color: "#1D3A90" }}>— for founders</span></h3>
                        <div className="grid-2col">
                            <div className="card-idea"><i className="fa-regular fa-lightbulb"></i><h4>You don’t need to be a patent expert</h4><p>You explain your product simply. The AI turns that into a strong draft. Attorneys handle the legal side. You stay focused on building.</p></div>
                            <div className="card-idea"><i className="fa-regular fa-eye"></i><h4>You stay in control</h4><p>No black box. You see your filing take shape in real time, collaborate, make changes quickly. You're not handing off your idea — you're working together.</p></div>
                            <div className="card-idea"><i className="fa-regular fa-calendar-check"></i><h4>File faster, file earlier</h4><p>Speed without quality is dangerous. AI + attorney means you file fast without filing weak. That speed is a weapon.</p></div>
                            <div className="card-idea"><i className="fa-regular fa-chart-bar"></i><h4>Your IP becomes an asset</h4><p>Investors want to know what you filed and why it matters. A patent built with tech + legal strategy adds real value.</p></div>
                        </div>
                        <div className="pill-divider"><hr /><i className="fa-regular fa-gem"></i><hr /></div>
                        <p style={{ fontSize: "1.3rem", fontWeight: "500", color: "#0B1E4A" }}>You finally have a better option. No more “cheap & risky” or “slow & expensive”. AI + real attorneys — built for startups. That’s the model.</p>
                    </div>
                </div>

                {/* <!-- NEWS / ARTICLE SECTION (inspired by expert legal / speed style) --> */}
                <div className="content-container">
                    <div className="news-article" data-aos="fade-up">
                        <div className="article-header">
                            <h1>Nothing But The Truth</h1>
                            <div className="byline"><span>📅 April 15, 2025</span> <span>⚖️ Emily Lou Steenwyk</span> <span>📄 Patent Damages Guide</span></div>
                        </div>
                        <h2>How to Calculate Damages in Patent Disputes: A 2025 Guide</h2>
                        <div className="legal-box">
                            <h3>1. What Are Patent Infringement Damages?</h3>
                            <p>Monetary awards granted to a patent holder when someone uses their patented invention without authorization. Under 35 U.S. Code § 284, a court must award damages “adequate to compensate for the infringement, but in no event less than a reasonable royalty.”</p>
                            <h3>2. Two Main Types</h3>
                            <p><strong>Reasonable royalty</strong> (Georgia‑Pacific factors) and <strong>lost profits</strong> (Panduit test).</p>
                        </div>
                        <table className="cost-table">
                            <tr><th>Damages type</th><th>definition / key requirement</th></tr>
                            <tr><td><strong>Reasonable royalty</strong></td><td>Georgia‑Pacific 15 factors, comparable licenses</td></tr>
                            <tr><td><strong>Lost profits</strong></td><td>Panduit test: demand, no substitutes, capacity, causation</td></tr>
                        </table>
                        <Link to={"/patents"} className="cta-mini"><i className="fa-solid fa-magnifying-glass"></i> Request an Expert Witness – ForensisGroup</Link>

                        <h2 style={{ marginTop: "3rem" }}>Understanding Patent Search Cost</h2>
                        <table className="cost-table">
                            <tr><th>Search type</th><th>estimated cost</th></tr>
                            <tr><td>Simple invention</td><td>$1,000 – $1,250</td></tr>
                            <tr><td>Moderately complex</td><td>$1,500 – $2,000</td></tr>
                            <tr><td>Highly complex / software</td><td>$2,000 – $3,000+</td></tr>
                        </table>
                        <div className="footnote">
                            <i className="fa-regular fa-circle-check" style={{ color: "#1D3A90" }}></i> <strong>Invalidity search pilot:</strong> $2,500 flat – comprehensive prior art, strategic insights.
                        </div>
                    </div>
                </div>

                {/* <!-- FINAL CLAIM (like final CTA but content) --> */}
                <div className="content-container">
                    <div className="final-claim" data-aos="flip-up">
                        <h2 style={{ fontSize: "clamp(2rem,5vw,3.5rem)" }}>AI gets you to 80% · attorneys take it to 100%</h2>
                        <p style={{ fontSize: "1.3rem" }}>Proprietary AI + O’Hanlon‑level legal excellence = patents that actually protect your edge. <strong>The new standard for startups: fast, affordable, defensible.</strong></p>
                        <div className="stat-row">
                            <span><i className="fa-regular fa-circle-check"></i> 70% faster process</span>
                            <span><i className="fa-regular fa-circle-check"></i> 100% O’Hanlon protected</span>
                            <span><i className="fa-regular fa-circle-check"></i> Zero quality compromise</span>
                        </div>
                        <Link to="/contact" className="btn btn-primary" style={{ marginTop: "2rem" }}>Secure your patented advantage</Link>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default History;